import { useMutation } from '@tanstack/react-query';
import type { JsonValue } from 'type-fest';

import { useRequest, type MutationFunction } from '@frontend/api';

import type { AgentConversation } from './types';

const getUseUpdateConversationKey = () => ['agents', 'conversation'];

type Payload = {
  name?: string;
  modelKey?: string;
  baseSystemPrompt?: string;
};
type UpdateConversationQueryParams = {
  uuid: string;
};

export const useUpdateConversation: MutationFunction<
  AgentConversation,
  Payload,
  [UpdateConversationQueryParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    (body) =>
      request<AgentConversation & JsonValue>(
        `/agents/conversations/${params.uuid}`,
        {
          init: {
            method: 'PATCH',
            body,
          },
        },
      ),
    {
      ...queryOptions,
      mutationKey: getUseUpdateConversationKey(),
    },
  );
};
